/**
 * add accordion functionality for menu items to .s-footer selector
 */
import jQuery from 'jquery'

export default class Sitemap {
  constructor(element) {
    if (!element) {
      return false
    }

    this.jQueryelement = jQuery(element)

    this._iniVars()

    this._createColumns()

    this._mobileAccordion()

    this._loaded()
  }

  _iniVars() {
    this.wrap = this.element

    this.nav = jQuery('.s-sitemap__tiles', this.wrap)

    this.items = jQuery('.s-sitemap__tiles__item', this.nav)

    this.title = jQuery('.s-sitemap__title', this.wrap)

    this.timer = 0
  }

  _createColumns() {
    if (this.items.length > 1) {
      let str =
        '<div class="s-sitemap__tiles__col s-sitemap__tiles__col--1"></div>'
      str +=
        '<div class="s-sitemap__tiles__col s-sitemap__tiles__col--2"></div>'
      str +=
        '<div class="s-sitemap__tiles__col s-sitemap__tiles__col--3"></div>'

      jQuery(str).prependTo(this.nav)

      this._moveColItemsToFooterCol()
    }
  }

  _moveColItemsToFooterCol() {
    this.items.each(function () {
      const ul = jQuery(this)

      if (ul.data('column') === 1) {
        ul.appendTo(jQuery('.s-sitemap__tiles__col--1', this.nav))
      }
      if (ul.data('column') === 2) {
        ul.appendTo(jQuery('.s-sitemap__tiles__col--2', this.nav))
      }
      if (ul.data('column') === 3) {
        ul.appendTo(jQuery('.s-sitemap__tiles__col--3', this.nav))
      }
    })
  }

  _mobileAccordion() {
    jQuery('button', this.title).on('click', (e) => {
      const targetElement = jQuery(e.currentTarget)

      this._hideOtherAccordionItems(
        targetElement.parents('.s-sitemap__tiles__item')
      )
    })
  }

  _hideOtherAccordionItems(item) {
    if (this.items.not(item).hasClass('active')) {
      this.items.not(item).removeClass('active')
      this.items
        .not(item)
        .find('> ul')
        .slideUp(200, () => {
          //   api.fn.moveWindowToObj(item)
          this._toggleAccordionItem(item)
        })
    } else {
      this._toggleAccordionItem(item)
    }
  }

  _toggleAccordionItem(item) {
    item.toggleClass('active')

    if (item.hasClass('active')) {
      item
        .find('> ul')
        .stop()
        .slideDown(300, () => {
          //   api.fn.moveWindowToObj(item)
        })
    } else {
      item.find('> ul').hide()
    }
  }

  _resetAccordion() {
    this.items.removeClass('active')
    this.items.find('> ul').removeAttr('style')
  }

  _loaded() {
    // api.fn.preloadContentLikeVue(this.wrap)
  }
}
